// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Autocomplete-module__font-s-10___KvIpC {
  font-size: 10px !important;
}

.Autocomplete-module__font-s-12___tPWem {
  font-size: 12px !important;
}

.Autocomplete-module__font-s-13___CTauY {
  font-size: 13px !important;
}

.Autocomplete-module__font-s-14___GLOB0 {
  font-size: 14px !important;
}

.Autocomplete-module__font-s-15___EWq_v {
  font-size: 15px !important;
}

.Autocomplete-module__font-s-16___Fcdq1 {
  font-size: 16px !important;
}

.Autocomplete-module__font-s-18___OPDqo {
  font-size: 18px !important;
}

.Autocomplete-module__font-s-20___YiSie {
  font-size: 20px !important;
}

.Autocomplete-module__font-s-22___giUrO {
  font-size: 22px !important;
}

.Autocomplete-module__font-s-28___q3nDE {
  font-size: 28px !important;
}

.Autocomplete-module__font-w-400___X2R9S {
  font-weight: 400 !important;
}

.Autocomplete-module__font-w-500___VY_UZ {
  font-weight: 500 !important;
}

.Autocomplete-module__font-w-600___qLNmy {
  font-weight: 600 !important;
}

.Autocomplete-module__font-w-700___glGSL {
  font-weight: 700 !important;
}

.Autocomplete-module__p-5___pIDke {
  padding: 5px !important;
}

.Autocomplete-module__p-12___cfoPQ {
  padding: 12px !important;
}

.Autocomplete-module__p-16___K5mb2 {
  padding: 16px !important;
}

.Autocomplete-module__p-30___aEXbU {
  padding: 30px !important;
}

.Autocomplete-module__p-b-0___y2LQD {
  padding-bottom: 0 !important;
}

.Autocomplete-module__p-b-5___gxcLG {
  padding-bottom: 5px !important;
}

.Autocomplete-module__p-b-10___WD0N3 {
  padding-bottom: 10px !important;
}

.Autocomplete-module__p-b-12___oNKiW {
  padding-bottom: 12px !important;
}

.Autocomplete-module__p-b-16___CYNZf {
  padding-bottom: 16px !important;
}

.Autocomplete-module__p-b-18___brChL {
  padding-bottom: 18px !important;
}

.Autocomplete-module__p-b-20___FQiPX {
  padding-bottom: 20px !important;
}

.Autocomplete-module__p-b-25___O73Ty {
  padding-bottom: 25px !important;
}

.Autocomplete-module__p-b-30___YODfp {
  padding-bottom: 30px !important;
}

.Autocomplete-module__p-b-50___x6eut {
  padding-bottom: 50px !important;
}

.Autocomplete-module__p-t-0___cwo8y {
  padding-top: 0 !important;
}

.Autocomplete-module__p-t-12___vG2BT {
  padding-top: 12px !important;
}

.Autocomplete-module__p-t-16___NRxSp {
  padding-top: 16px !important;
}

.Autocomplete-module__p-t-18___DNuj6 {
  padding-top: 18px !important;
}

.Autocomplete-module__p-t-20___iwof4 {
  padding-top: 20px !important;
}

.Autocomplete-module__p-t-30___iKssy {
  padding-top: 30px !important;
}

.Autocomplete-module__p-t-40___OnmnT {
  padding-top: 40px !important;
}

.Autocomplete-module__p-t-50___Vub3i {
  padding-top: 50px !important;
}

.Autocomplete-module__p-l-20___ht5ZI {
  padding-left: 20px !important;
}

.Autocomplete-module__p-l-30___yIy1y {
  padding-left: 30px !important;
}

.Autocomplete-module__p-l-40___Feq8X {
  padding-left: 40px !important;
}

.Autocomplete-module__p-r-16___uKs6y {
  padding-right: 16px !important;
}

.Autocomplete-module__p-r-20___QJjPx {
  padding-right: 20px !important;
}

.Autocomplete-module__p-r-30___KGpPU {
  padding-right: 30px !important;
}

.Autocomplete-module__p-r-50___QnyIy {
  padding-right: 50px !important;
}

.Autocomplete-module__p-r-60___OLwRn {
  padding-right: 60px !important;
}

.Autocomplete-module__m-b-1___x3tws {
  margin-bottom: 1px !important;
}

.Autocomplete-module__m-b-2___my0Hm {
  margin-bottom: 2px !important;
}

.Autocomplete-module__m-b-6___Tk90M {
  margin-bottom: 6px !important;
}

.Autocomplete-module__m-b-8___Yko5y {
  margin-bottom: 8px !important;
}

.Autocomplete-module__m-b-10___HfA9l {
  margin-bottom: 10px !important;
}

.Autocomplete-module__m-b-14___H2Ple {
  margin-bottom: 14px !important;
}

.Autocomplete-module__m-b-16___cFH__ {
  margin-bottom: 16px !important;
}

.Autocomplete-module__m-b-20___cJGiY {
  margin-bottom: 20px !important;
}

.Autocomplete-module__m-b-22___dK22l {
  margin-bottom: 22px !important;
}

.Autocomplete-module__m-b-24___rGp4O {
  margin-bottom: 24px !important;
}

.Autocomplete-module__m-b-30___h0bOS {
  margin-bottom: 30px !important;
}

.Autocomplete-module__m-b-32___HvGDB {
  margin-bottom: 32px !important;
}

.Autocomplete-module__m-b-40___dfm5v {
  margin-bottom: 40px !important;
}

.Autocomplete-module__m-t-2___uBSoX {
  margin-top: 2px !important;
}

.Autocomplete-module__m-t-3___c4ojq {
  margin-top: 3px !important;
}

.Autocomplete-module__m-t-4___WRoc2 {
  margin-top: 4px !important;
}

.Autocomplete-module__m-t-5___vOugd {
  margin-top: 5px !important;
}

.Autocomplete-module__m-t-8___eoS3G {
  margin-top: 8px !important;
}

.Autocomplete-module__m-t-10___m2Gp6 {
  margin-top: 10px !important;
}

.Autocomplete-module__m-t-15___fiWJv {
  margin-top: 15px !important;
}

.Autocomplete-module__m-t-16___hCeNo {
  margin-top: 16px !important;
}

.Autocomplete-module__m-t-20___bliKw {
  margin-top: 20px !important;
}

.Autocomplete-module__m-t-22___ofkmm {
  margin-top: 22px !important;
}

.Autocomplete-module__m-t-30___kOXBW {
  margin-top: 30px !important;
}

.Autocomplete-module__m-t-32___zlbCW {
  margin-top: 32px !important;
}

.Autocomplete-module__m-l-auto___Rk7gN {
  margin-left: auto !important;
}

.Autocomplete-module__m-l-4___qmsd3 {
  margin-left: 4px !important;
}

.Autocomplete-module__m-l-5___vHMWq {
  margin-left: 5px !important;
}

.Autocomplete-module__m-l-6___U8FRZ {
  margin-left: 6px !important;
}

.Autocomplete-module__m-l-8___ea7ge {
  margin-left: 8px !important;
}

.Autocomplete-module__m-l-10___r1Swa {
  margin-left: 10px !important;
}

.Autocomplete-module__m-l-16___ryol1 {
  margin-left: 16px !important;
}

.Autocomplete-module__m-l-20___Aw1wm {
  margin-left: 20px !important;
}

.Autocomplete-module__m-l-24___SkQ9B {
  margin-left: 24px !important;
}

.Autocomplete-module__m-l-30___BAqeG {
  margin-left: 30px !important;
}

.Autocomplete-module__m-l-35___uabzc {
  margin-left: 35px !important;
}

.Autocomplete-module__m-l-40___UUYL4 {
  margin-left: 40px !important;
}

.Autocomplete-module__m-r-8___lZf08 {
  margin-right: 8px !important;
}

.Autocomplete-module__m-r-10___ZZ0Xp {
  margin-right: 10px !important;
}

.Autocomplete-module__m-r-16___lZ_Eg {
  margin-right: 16px !important;
}

.Autocomplete-module__m-r-20___wq8b6 {
  margin-right: 20px !important;
}

.Autocomplete-module__m-r-24___WpB5J {
  margin-right: 24px !important;
}

.Autocomplete-module__m-r-30___PsJMX {
  margin-right: 30px !important;
}

.Autocomplete-module__m-r-40___v3G7d {
  margin-right: 40px !important;
}

.Autocomplete-module__border-r-3___vuu7e {
  border-radius: 3px !important;
}

.Autocomplete-module__border-r-4___ba3ZY {
  border-radius: 4px !important;
}

.Autocomplete-module__border-r-6___loH7x {
  border-radius: 6px !important;
}

.Autocomplete-module__border-r-10___di4v5 {
  border-radius: 10px !important;
}

.Autocomplete-module__border-r-12___CPIph {
  border-radius: 12px !important;
}

.Autocomplete-module__border-r-16___nQTIB {
  border-radius: 16px !important;
}

.Autocomplete-module__border-r-50___ecrl_ {
  border-radius: 50% !important;
}

.Autocomplete-module__primary-border___prZgr {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Autocomplete-module__primary-border-b___Mdbg0 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Autocomplete-module__primary-border-t___Rl4qW {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Autocomplete-module__primary-border-l___ke_v_ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Autocomplete-module__primary-border-r___DmdfH {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Autocomplete-module__secondary-border___m1hWN {
  border: 1px solid #637768;
}

.Autocomplete-module__secondary-border-b___fUcB8 {
  border-bottom: 1px solid #637768;
}

.Autocomplete-module__secondary-border-t___XPd47 {
  border-top: 1px solid #637768;
}

.Autocomplete-module__secondary-border-l___m6_vl {
  border-left: 1px solid #637768;
}

.Autocomplete-module__secondary-border-r___eYNXE {
  border-right: 1px solid #637768;
}

.Autocomplete-module__gap-0___UiG9M {
  gap: 0 !important;
}

.Autocomplete-module__gap-2___Kk4KJ {
  gap: 2px !important;
}

.Autocomplete-module__gap-4___z9vJz {
  gap: 4px !important;
}

.Autocomplete-module__gap-5___eQv7w {
  gap: 5px !important;
}

.Autocomplete-module__gap-6___jN3jb {
  gap: 6px !important;
}

.Autocomplete-module__gap-8___uwcu9 {
  gap: 8px !important;
}

.Autocomplete-module__gap-10___o3hVe {
  gap: 10px !important;
}

.Autocomplete-module__gap-12___JwTk4 {
  gap: 12px !important;
}

.Autocomplete-module__gap-14___YLGYg {
  gap: 14px !important;
}

.Autocomplete-module__gap-16___BeXjs {
  gap: 16px !important;
}

.Autocomplete-module__gap-18___sZF_z {
  gap: 18px !important;
}

.Autocomplete-module__gap-20___lTSYV {
  gap: 20px !important;
}

.Autocomplete-module__gap-24___EO24u {
  gap: 24px !important;
}

.Autocomplete-module__gap-26___pKR_W {
  gap: 26px !important;
}

.Autocomplete-module__gap-30___hjkB5 {
  gap: 30px !important;
}

.Autocomplete-module__gap-32___VtyDX {
  gap: 32px !important;
}

.Autocomplete-module__gap-40____ximU {
  gap: 40px !important;
}

.Autocomplete-module__gap-50___zM00W {
  gap: 50px !important;
}

.Autocomplete-module__flex-1___q8kq4 {
  flex: 1;
}

.Autocomplete-module__flex-none___EvgVR {
  flex: none !important;
}

.Autocomplete-module__flex-column___GaQng {
  display: flex;
  flex-direction: column !important;
}

.Autocomplete-module__flex-row___niEsf {
  display: flex;
  flex-direction: row !important;
}

.Autocomplete-module__vertically-centered___QgD6m {
  display: flex;
  align-items: center !important;
}

.Autocomplete-module__horizontally-centered___IgGSr {
  display: flex;
  justify-content: center !important;
}

.Autocomplete-module__horizontally-end___XbV1r {
  display: flex;
  justify-content: end !important;
}

.Autocomplete-module__vertically-start___DwmYY {
  display: flex;
  align-items: start !important;
}

.Autocomplete-module__space-between___w1RsZ {
  display: flex;
  justify-content: space-between !important;
}

.Autocomplete-module__flex-wrap___Ci5Ll {
  flex-wrap: wrap !important;
}

.Autocomplete-module__height-100___O5iNW {
  height: 100%;
}

.Autocomplete-module__width-50___d9bPi {
  width: 50% !important;
}

.Autocomplete-module__width-100___gn6LP {
  width: 100%;
}

.Autocomplete-module__cursor-pointer___FXZJ8 {
  cursor: pointer;
}

.Autocomplete-module__cursor-not-allowed___PKc7k {
  cursor: not-allowed !important;
}

.Autocomplete-module__absolute-centered___EwLZY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Autocomplete-module__absolute___qD9lg {
  position: absolute;
}

.Autocomplete-module__relative____q9xW {
  position: relative;
}

.Autocomplete-module__fixed___EXkAU {
  position: fixed;
}

.Autocomplete-module__visible___InU5Z {
  opacity: 1;
}

.Autocomplete-module__invisible___QVJpP {
  opacity: 0;
}

.Autocomplete-module__col-90___BcLjr {
  width: 90% !important;
}

.Autocomplete-module__col-auto___CoMXK {
  width: auto !important;
}

.Autocomplete-module__medical-tabs___agJuJ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Autocomplete-module__medical-table-new___kLlUr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Autocomplete-module__medical-table-new___kLlUr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Autocomplete-module__medical-table-new___kLlUr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Autocomplete-module__medical-table-new___kLlUr::-webkit-scrollbar-track {
  display: none;
}
.Autocomplete-module__medical-table-new___kLlUr.Autocomplete-module__no-pagination___aWwId {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Autocomplete-module__medical-table-new___kLlUr.Autocomplete-module__no-pagination___aWwId:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Autocomplete-module__medical-table-new___kLlUr.Autocomplete-module__no-pagination___aWwId::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Autocomplete-module__medical-table-new___kLlUr.Autocomplete-module__no-pagination___aWwId::-webkit-scrollbar-track {
  display: none;
}

.Autocomplete-module__medical-table-empty___v4Pc3 {
  padding: 14px 40px !important;
}

.Autocomplete-module__icon-btn___KBUUD {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Autocomplete-module__search-icon___sOGVk {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Autocomplete-module__disable-select___X_Wsy {
  user-select: none;
}

.Autocomplete-module__break-word___w7EUl {
  word-break: break-word;
}

.Autocomplete-module__popup-clear-btn___vUAn9 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Autocomplete-module__scroll-m-b-20___HTjvu {
  scroll-margin-bottom: 20px;
}

.Autocomplete-module__paper___KuRjo {
  box-shadow: 0 0 2px 0 #375844;
  background-color: white;
  pointer-events: auto;
  overflow-y: scroll;
  max-height: 40vh;
  z-index: 100;
}
.Autocomplete-module__paper___KuRjo > * {
  padding: 15px;
}
.Autocomplete-module__paper___KuRjo > *:hover {
  background-color: #f2f2f2;
}
.Autocomplete-module__paper___KuRjo .Autocomplete-module__viewMore___gT0mU {
  color: #0091ff;
  text-align: left;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Autocomplete/Autocomplete.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA8pBF;AA5pBE;EACE,aAAA;AA8pBJ;AA5pBI;EACE,yBAAA;AA8pBN;AA1pBE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.paper {\n  box-shadow: 0 0 2px 0 get-color(greenNew, dark);\n  background-color: get-color(white);\n  pointer-events: auto;\n  overflow-y: scroll;\n  max-height: 40vh;\n  z-index: 100;\n\n  & > * {\n    padding: 15px;\n\n    &:hover {\n      background-color: get-color(gray, lightest);\n    }\n  }\n\n  .viewMore {\n    color: get-color(blue);\n    text-align: left;\n    width: 100%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Autocomplete-module__font-s-10___KvIpC`,
	"fontS12": `Autocomplete-module__font-s-12___tPWem`,
	"fontS13": `Autocomplete-module__font-s-13___CTauY`,
	"fontS14": `Autocomplete-module__font-s-14___GLOB0`,
	"fontS15": `Autocomplete-module__font-s-15___EWq_v`,
	"fontS16": `Autocomplete-module__font-s-16___Fcdq1`,
	"fontS18": `Autocomplete-module__font-s-18___OPDqo`,
	"fontS20": `Autocomplete-module__font-s-20___YiSie`,
	"fontS22": `Autocomplete-module__font-s-22___giUrO`,
	"fontS28": `Autocomplete-module__font-s-28___q3nDE`,
	"fontW400": `Autocomplete-module__font-w-400___X2R9S`,
	"fontW500": `Autocomplete-module__font-w-500___VY_UZ`,
	"fontW600": `Autocomplete-module__font-w-600___qLNmy`,
	"fontW700": `Autocomplete-module__font-w-700___glGSL`,
	"p5": `Autocomplete-module__p-5___pIDke`,
	"p12": `Autocomplete-module__p-12___cfoPQ`,
	"p16": `Autocomplete-module__p-16___K5mb2`,
	"p30": `Autocomplete-module__p-30___aEXbU`,
	"pB0": `Autocomplete-module__p-b-0___y2LQD`,
	"pB5": `Autocomplete-module__p-b-5___gxcLG`,
	"pB10": `Autocomplete-module__p-b-10___WD0N3`,
	"pB12": `Autocomplete-module__p-b-12___oNKiW`,
	"pB16": `Autocomplete-module__p-b-16___CYNZf`,
	"pB18": `Autocomplete-module__p-b-18___brChL`,
	"pB20": `Autocomplete-module__p-b-20___FQiPX`,
	"pB25": `Autocomplete-module__p-b-25___O73Ty`,
	"pB30": `Autocomplete-module__p-b-30___YODfp`,
	"pB50": `Autocomplete-module__p-b-50___x6eut`,
	"pT0": `Autocomplete-module__p-t-0___cwo8y`,
	"pT12": `Autocomplete-module__p-t-12___vG2BT`,
	"pT16": `Autocomplete-module__p-t-16___NRxSp`,
	"pT18": `Autocomplete-module__p-t-18___DNuj6`,
	"pT20": `Autocomplete-module__p-t-20___iwof4`,
	"pT30": `Autocomplete-module__p-t-30___iKssy`,
	"pT40": `Autocomplete-module__p-t-40___OnmnT`,
	"pT50": `Autocomplete-module__p-t-50___Vub3i`,
	"pL20": `Autocomplete-module__p-l-20___ht5ZI`,
	"pL30": `Autocomplete-module__p-l-30___yIy1y`,
	"pL40": `Autocomplete-module__p-l-40___Feq8X`,
	"pR16": `Autocomplete-module__p-r-16___uKs6y`,
	"pR20": `Autocomplete-module__p-r-20___QJjPx`,
	"pR30": `Autocomplete-module__p-r-30___KGpPU`,
	"pR50": `Autocomplete-module__p-r-50___QnyIy`,
	"pR60": `Autocomplete-module__p-r-60___OLwRn`,
	"mB1": `Autocomplete-module__m-b-1___x3tws`,
	"mB2": `Autocomplete-module__m-b-2___my0Hm`,
	"mB6": `Autocomplete-module__m-b-6___Tk90M`,
	"mB8": `Autocomplete-module__m-b-8___Yko5y`,
	"mB10": `Autocomplete-module__m-b-10___HfA9l`,
	"mB14": `Autocomplete-module__m-b-14___H2Ple`,
	"mB16": `Autocomplete-module__m-b-16___cFH__`,
	"mB20": `Autocomplete-module__m-b-20___cJGiY`,
	"mB22": `Autocomplete-module__m-b-22___dK22l`,
	"mB24": `Autocomplete-module__m-b-24___rGp4O`,
	"mB30": `Autocomplete-module__m-b-30___h0bOS`,
	"mB32": `Autocomplete-module__m-b-32___HvGDB`,
	"mB40": `Autocomplete-module__m-b-40___dfm5v`,
	"mT2": `Autocomplete-module__m-t-2___uBSoX`,
	"mT3": `Autocomplete-module__m-t-3___c4ojq`,
	"mT4": `Autocomplete-module__m-t-4___WRoc2`,
	"mT5": `Autocomplete-module__m-t-5___vOugd`,
	"mT8": `Autocomplete-module__m-t-8___eoS3G`,
	"mT10": `Autocomplete-module__m-t-10___m2Gp6`,
	"mT15": `Autocomplete-module__m-t-15___fiWJv`,
	"mT16": `Autocomplete-module__m-t-16___hCeNo`,
	"mT20": `Autocomplete-module__m-t-20___bliKw`,
	"mT22": `Autocomplete-module__m-t-22___ofkmm`,
	"mT30": `Autocomplete-module__m-t-30___kOXBW`,
	"mT32": `Autocomplete-module__m-t-32___zlbCW`,
	"mLAuto": `Autocomplete-module__m-l-auto___Rk7gN`,
	"mL4": `Autocomplete-module__m-l-4___qmsd3`,
	"mL5": `Autocomplete-module__m-l-5___vHMWq`,
	"mL6": `Autocomplete-module__m-l-6___U8FRZ`,
	"mL8": `Autocomplete-module__m-l-8___ea7ge`,
	"mL10": `Autocomplete-module__m-l-10___r1Swa`,
	"mL16": `Autocomplete-module__m-l-16___ryol1`,
	"mL20": `Autocomplete-module__m-l-20___Aw1wm`,
	"mL24": `Autocomplete-module__m-l-24___SkQ9B`,
	"mL30": `Autocomplete-module__m-l-30___BAqeG`,
	"mL35": `Autocomplete-module__m-l-35___uabzc`,
	"mL40": `Autocomplete-module__m-l-40___UUYL4`,
	"mR8": `Autocomplete-module__m-r-8___lZf08`,
	"mR10": `Autocomplete-module__m-r-10___ZZ0Xp`,
	"mR16": `Autocomplete-module__m-r-16___lZ_Eg`,
	"mR20": `Autocomplete-module__m-r-20___wq8b6`,
	"mR24": `Autocomplete-module__m-r-24___WpB5J`,
	"mR30": `Autocomplete-module__m-r-30___PsJMX`,
	"mR40": `Autocomplete-module__m-r-40___v3G7d`,
	"borderR3": `Autocomplete-module__border-r-3___vuu7e`,
	"borderR4": `Autocomplete-module__border-r-4___ba3ZY`,
	"borderR6": `Autocomplete-module__border-r-6___loH7x`,
	"borderR10": `Autocomplete-module__border-r-10___di4v5`,
	"borderR12": `Autocomplete-module__border-r-12___CPIph`,
	"borderR16": `Autocomplete-module__border-r-16___nQTIB`,
	"borderR50": `Autocomplete-module__border-r-50___ecrl_`,
	"primaryBorder": `Autocomplete-module__primary-border___prZgr`,
	"primaryBorderB": `Autocomplete-module__primary-border-b___Mdbg0`,
	"primaryBorderT": `Autocomplete-module__primary-border-t___Rl4qW`,
	"primaryBorderL": `Autocomplete-module__primary-border-l___ke_v_`,
	"primaryBorderR": `Autocomplete-module__primary-border-r___DmdfH`,
	"secondaryBorder": `Autocomplete-module__secondary-border___m1hWN`,
	"secondaryBorderB": `Autocomplete-module__secondary-border-b___fUcB8`,
	"secondaryBorderT": `Autocomplete-module__secondary-border-t___XPd47`,
	"secondaryBorderL": `Autocomplete-module__secondary-border-l___m6_vl`,
	"secondaryBorderR": `Autocomplete-module__secondary-border-r___eYNXE`,
	"gap0": `Autocomplete-module__gap-0___UiG9M`,
	"gap2": `Autocomplete-module__gap-2___Kk4KJ`,
	"gap4": `Autocomplete-module__gap-4___z9vJz`,
	"gap5": `Autocomplete-module__gap-5___eQv7w`,
	"gap6": `Autocomplete-module__gap-6___jN3jb`,
	"gap8": `Autocomplete-module__gap-8___uwcu9`,
	"gap10": `Autocomplete-module__gap-10___o3hVe`,
	"gap12": `Autocomplete-module__gap-12___JwTk4`,
	"gap14": `Autocomplete-module__gap-14___YLGYg`,
	"gap16": `Autocomplete-module__gap-16___BeXjs`,
	"gap18": `Autocomplete-module__gap-18___sZF_z`,
	"gap20": `Autocomplete-module__gap-20___lTSYV`,
	"gap24": `Autocomplete-module__gap-24___EO24u`,
	"gap26": `Autocomplete-module__gap-26___pKR_W`,
	"gap30": `Autocomplete-module__gap-30___hjkB5`,
	"gap32": `Autocomplete-module__gap-32___VtyDX`,
	"gap40": `Autocomplete-module__gap-40____ximU`,
	"gap50": `Autocomplete-module__gap-50___zM00W`,
	"flex1": `Autocomplete-module__flex-1___q8kq4`,
	"flexNone": `Autocomplete-module__flex-none___EvgVR`,
	"flexColumn": `Autocomplete-module__flex-column___GaQng`,
	"flexRow": `Autocomplete-module__flex-row___niEsf`,
	"verticallyCentered": `Autocomplete-module__vertically-centered___QgD6m`,
	"horizontallyCentered": `Autocomplete-module__horizontally-centered___IgGSr`,
	"horizontallyEnd": `Autocomplete-module__horizontally-end___XbV1r`,
	"verticallyStart": `Autocomplete-module__vertically-start___DwmYY`,
	"spaceBetween": `Autocomplete-module__space-between___w1RsZ`,
	"flexWrap": `Autocomplete-module__flex-wrap___Ci5Ll`,
	"height100": `Autocomplete-module__height-100___O5iNW`,
	"width50": `Autocomplete-module__width-50___d9bPi`,
	"width100": `Autocomplete-module__width-100___gn6LP`,
	"cursorPointer": `Autocomplete-module__cursor-pointer___FXZJ8`,
	"cursorNotAllowed": `Autocomplete-module__cursor-not-allowed___PKc7k`,
	"absoluteCentered": `Autocomplete-module__absolute-centered___EwLZY`,
	"absolute": `Autocomplete-module__absolute___qD9lg`,
	"relative": `Autocomplete-module__relative____q9xW`,
	"fixed": `Autocomplete-module__fixed___EXkAU`,
	"visible": `Autocomplete-module__visible___InU5Z`,
	"invisible": `Autocomplete-module__invisible___QVJpP`,
	"col90": `Autocomplete-module__col-90___BcLjr`,
	"colAuto": `Autocomplete-module__col-auto___CoMXK`,
	"medicalTabs": `Autocomplete-module__medical-tabs___agJuJ`,
	"medicalTableNew": `Autocomplete-module__medical-table-new___kLlUr`,
	"noPagination": `Autocomplete-module__no-pagination___aWwId`,
	"medicalTableEmpty": `Autocomplete-module__medical-table-empty___v4Pc3`,
	"iconBtn": `Autocomplete-module__icon-btn___KBUUD`,
	"searchIcon": `Autocomplete-module__search-icon___sOGVk`,
	"disableSelect": `Autocomplete-module__disable-select___X_Wsy`,
	"breakWord": `Autocomplete-module__break-word___w7EUl`,
	"popupClearBtn": `Autocomplete-module__popup-clear-btn___vUAn9`,
	"scrollMB20": `Autocomplete-module__scroll-m-b-20___HTjvu`,
	"paper": `Autocomplete-module__paper___KuRjo`,
	"viewMore": `Autocomplete-module__viewMore___gT0mU`
};
module.exports = ___CSS_LOADER_EXPORT___;
